import {Subject} from 'rxjs';

export const refreshJobs$ = new Subject<void>();

export const refreshMemberProducts$ = new Subject<void>();

export const refreshJobsUsers$ = new Subject<void>();

export const refreshJobProducts$ = new Subject<void>();